import { TrustFactor, UseRowsReturn } from '@nettbureau/featured-core';
import { Featured } from '../featured/Featured';

interface TrustFactorsSectionProps {
  trustFactors: UseRowsReturn<TrustFactor>;
  containerTitle: string;
}

export function TrustFactorsSection({
  trustFactors,
  containerTitle,
}: TrustFactorsSectionProps) {
  return (
    <Featured<TrustFactor>
      rows={trustFactors}
      title={containerTitle}
      contactUrl={null}
      cardRenderer={(attributes) => {
        return (
          <img
            src={attributes.background?.url}
            alt={attributes.background?.alt ?? ''}
          />
        );
      }}
    />
  );
}
